import { create } from 'zustand'
import axios from 'axios'
import { cleanParamsFilter } from 'Utils/cleanParamsFilter'

import { CRUDBaseStore } from './Base/CRUD'

export const API_SLUG = 'machine'

export const INITIAL_STATE = {
  id: 0,
  pillingType: '',
  machineCode: '',
  brand: '',
  machineModel: '',
  machineTypeID: '',
  machineType: null as any,
}

export interface MachineStore extends CRUDBaseStore {
  types: any[]
  getOne: (id: any) => Promise<{ success: boolean; data: any }>
  setTypes: (types: any) => void
  getTypes: () => Promise<{ success: boolean; data: any }>
}

export const useMachineStore = create<MachineStore>((set, get) => ({
  data: [],
  error: undefined,
  loading: false,
  selected: INITIAL_STATE,
  types: [],
  setError: error => set({ error }),
  setSelected: selected => set({ selected }),
  setLoading: loading => set({ loading }),
  setTypes: types => set({ types }),
  getAll: async (params = {}) => {
    try {
      const response = await axios.get(`/${API_SLUG}`, {
        params: cleanParamsFilter(params),
      })
      set({ data: response.data })

      return {
        success: true,
        data: response.data,
      }
    } catch (error: any) {
      set({ error })

      return {
        success: false,
        data: (error?.response?.data?.message ?? '').toString(),
      }
    }
  },
  getOne: async (id: any) => {
    try {
      const response = await axios.get(`/${API_SLUG}/${id}`)
      set({ selected: response.data })

      return {
        success: true,
        data: response.data,
      }
    } catch (error: any) {
      set({ error })
      return {
        success: false,
        data: (error?.response?.data?.message ?? '').toString(),
      }
    }
  },
  getTypes: async () => {
    try {
      const response = await axios.get(`/machineType`)
      set({ types: response.data })

      return {
        success: true,
        data: response.data,
      }
    } catch (error: any) {
      set({ error })

      return {
        success: false,
        data: (error?.response?.data?.message ?? '').toString(),
      }
    }
  },
  create: async data => {
    const formData = new FormData()
    Object.keys(data).forEach(key => {
      if (data[key] !== null && data[key] !== undefined) {
        formData.append(key, data[key])
      }
    })

    try {
      const response = await axios.post(`/${API_SLUG}`, formData)

      return {
        success: true,
        data: response.data,
      }
    } catch (error: any) {
      set({ error })

      return {
        success: false,
        data: (error?.response?.data?.message ?? '').toString(),
      }
    }
  },
  edit: async (id, data) => {
    const formData = new FormData()
    Object.keys(data).forEach(key => {
      if (data[key] !== null && data[key] !== undefined) {
        formData.append(key, data[key])
      }
    })

    try {
      const response = await axios.patch(`/${API_SLUG}/${id}`, formData)

      return {
        success: true,
        data: response.data,
      }
    } catch (error: any) {
      set({ error })

      return {
        success: false,
        data: (error?.response?.data?.message ?? '').toString(),
      }
    }
  },
  delete: async id => {
    try {
      const response = await axios.delete(`/${API_SLUG}/${id}`)

      return {
        success: true,
        data: response.data,
      }
    } catch (error: any) {
      set({ error })

      return {
        success: false,
        data: (error?.response?.data?.message ?? '').toString(),
      }
    }
  },
  clearState: () =>
    set({
      data: [],
      error: undefined,
      loading: false,
      selected: INITIAL_STATE,
    }),
}))
